module.exports = __webpack_public_path__ + "img/nouveau-permis-l.becb689a.jpg";